module.exports = "/_next/static/images/up-0f2b26835b83864465e57296878fcb33.svg";